var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConstruction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.47,147.83c.49-3.55-4.51-6.46-8.27-6.76-1.79-.15-3.65.13-5.35-.47-3.68-1.28-5.15-6-8.74-7.55-2.68-1.13-5.77-.12-8.38,1.19s-5.17,3-8.08,3.14c-2.52.16-5.27-.77-7.48.46-1.65.92-2.51,2.82-4,3.94a9.6,9.6,0,0,1-5.27,1.43,14.84,14.84,0,0,0-5.44.89c-1.68.77-3.07,2.54-2.72,4.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.48,53.48c.51-3.71-4.73-6.76-8.66-7.08-1.87-.15-3.82.14-5.6-.48-3.85-1.34-5.38-6.31-9.14-7.9-2.81-1.18-6-.13-8.76,1.24s-5.41,3.1-8.45,3.29c-2.65.17-5.52-.81-7.83.48-1.73,1-2.63,2.95-4.22,4.12a10.06,10.06,0,0,1-5.51,1.5,15.35,15.35,0,0,0-5.69.93c-1.75.8-3.21,2.66-2.84,4.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.86,181.47c.38-2.78-3.55-5.08-6.5-5.31-1.41-.12-2.88.1-4.21-.37-2.89-1-4-4.74-6.87-5.93-2.11-.89-4.54-.1-6.58.93s-4.07,2.32-6.36,2.47c-2,.13-4.14-.61-5.88.36-1.3.73-2,2.22-3.17,3.1a7.58,7.58,0,0,1-4.14,1.12,11.78,11.78,0,0,0-4.27.7,3.39,3.39,0,0,0-2.14,3.43Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.27,147.37c.27-2-2.58-3.68-4.72-3.85a12.38,12.38,0,0,1-3-.27c-2.1-.73-2.93-3.44-5-4.3-1.53-.64-3.29-.07-4.77.68s-3,1.68-4.61,1.79c-1.44.09-3-.44-4.26.26-.94.52-1.44,1.61-2.3,2.25a5.55,5.55,0,0,1-3,.81,8.46,8.46,0,0,0-3.09.51,2.43,2.43,0,0,0-1.55,2.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.66,280.68c.38-2.79-3.55-5.08-6.51-5.32A16.72,16.72,0,0,1,244,275c-2.9-1-4-4.75-6.87-5.94-2.11-.89-4.54-.09-6.59.94s-4.06,2.32-6.35,2.47c-2,.12-4.14-.61-5.88.36-1.3.72-2,2.21-3.17,3.09a7.53,7.53,0,0,1-4.15,1.13,11.61,11.61,0,0,0-4.27.7,3.35,3.35,0,0,0-2.13,3.42Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.25,70.12c.39-2.79-3.54-5.08-6.5-5.32a16.84,16.84,0,0,1-4.21-.36c-2.89-1-4-4.74-6.87-5.94-2.11-.88-4.53-.09-6.58.94s-4.07,2.32-6.35,2.47c-2,.12-4.15-.61-5.89.36-1.29.72-2,2.22-3.17,3.1a7.55,7.55,0,0,1-4.14,1.12,11.57,11.57,0,0,0-4.27.7,3.38,3.38,0,0,0-2.14,3.42Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.66,51.85c.48-3.46-4.4-6.3-8.06-6.59-1.75-.14-3.56.12-5.22-.45-3.58-1.25-5-5.89-8.51-7.36-2.62-1.11-5.63-.12-8.17,1.15s-5,2.89-7.87,3.07c-2.47.15-5.14-.76-7.3.44-1.61.9-2.45,2.75-3.93,3.85a9.47,9.47,0,0,1-5.14,1.39,14.51,14.51,0,0,0-5.29.86c-1.64.75-3,2.48-2.65,4.25Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.27,
    y: 305.8,
    width: 179.66,
    height: 5.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.27,
    y: 307.28,
    width: 5.77,
    height: 164.04,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.66,
    y: 307.28,
    width: 4.07,
    height: 164.04,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.03,
    y: 307.28,
    width: 4.07,
    height: 164.04,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.21,
    y: 307.28,
    width: 2.04,
    height: 164.04,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.98,
    y: 300.41,
    width: 2.04,
    height: 170.9,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.45,
    y: 307.28,
    width: 6.69,
    height: 164.04,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.25,
    y: 297.9,
    width: 2.04,
    height: 173.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.5,
    y: 307.28,
    width: 2.04,
    height: 164.04,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.52,
    y: 307.28,
    width: 9.27,
    height: 164.04,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.16,
    y: 336.69,
    width: 247.96,
    height: 4.95,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.16,
    y: 423.53,
    width: 247.96,
    height: 7.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.16,
    y: 379.9,
    width: 247.96,
    height: 3.8,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.27,
    y: 336.69,
    width: 7.83,
    height: 134.62,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.36,
    y: 388.41,
    width: 23.77,
    height: 82.9,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.52,383.13c.11.57,40.88,41,40.88,41H451v-4.2h-5v-3.75h-4.09v-3.86h-3.06V409h-3.41v-4.09h-3.75v-3.52h-4.43v-4.09h-3.4v-2.65h-3.3V391h-3.4v-4.31h-3.87V383.7H405",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.84,339.91c-.11.57-40.88,41-40.88,41h-5.57v-4.2h5V373h4.09V369.1h3.06v-3.3H422v-4.08h3.75V358.2h4.43v-4.09h3.4v-2.66h3.3v-3.7h3.4v-4.32h3.87v-2.95h8.25",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.84,429.9c-.11.57-40.88,41-40.88,41h-5.57v-4.21h5V463h4.09v-3.86h3.06v-3.3H422V451.7h3.75v-3.52h4.43V444.1h3.4v-2.66h3.3v-3.7h3.4v-4.32h3.87v-2.95h8.25",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.68,370.55H382.43a.7.7,0,0,0,0-1.39H218.68a.7.7,0,0,0,0,1.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.2,424.47a36.37,36.37,0,0,0,19.19,17,38.12,38.12,0,0,0,27.22,0,37,37,0,0,0,12.94-8.19.69.69,0,0,0-1-1c-12.93,12.71-34.3,13.64-48.35,2.25a33.48,33.48,0,0,1-8.82-10.82c-.41-.79-1.6-.09-1.2.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.35,384c7.27,4.54,14.86,9.25,23.46,10.65a35.77,35.77,0,0,0,21.44-3.32,34.91,34.91,0,0,0,10.2-7.64c.6-.65-.38-1.64-1-1A34.44,34.44,0,0,1,390,393c-7.85,1.58-15.58.08-22.75-3.3a121.77,121.77,0,0,1-12.16-6.94c-.76-.47-1.45.72-.7,1.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.85,339.91v85.66a.69.69,0,0,0,1.38,0V339.91a.69.69,0,0,0-1.38,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.84,294v85.65a.69.69,0,0,0,1.38,0V294a.69.69,0,0,0-1.38,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.14,
    y: 365.7,
    width: 23.45,
    height: 14.09,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.21 380.16 262.84 370.11 256.78 380.15 249.29 370.09 242.28 380.14 242.16 379.98 235.03 370.09 227.03 380.12 226.92 379.99 218.94 370.65 219.15 370.47 227.02 379.68 235.04 369.63 242.28 379.66 249.28 369.62 256.76 379.65 262.82 369.61 262.94 369.77 270.18 379.65 275.75 369.62 284.79 379.67 291.21 369.61 298.44 379.65 303.81 370.85 304.05 370.99 298.46 380.15 298.34 379.98 291.23 370.1 284.82 380.13 284.7 379.99 275.8 370.09 270.21 380.16",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.68 381.09 284.28 370.5 277.27 380.59 277.16 380.47 268.61 371.44 263.39 380.62 263.27 380.45 255.71 370.52 249.87 380.15 249.74 379.99 242.46 370.51 235.51 380.6 227.28 370.49 219.15 379.99 218.94 379.81 227.28 370.05 235.49 380.14 242.44 370.04 249.84 379.66 255.69 370.02 255.81 370.19 263.36 380.12 268.56 370.98 277.24 380.15 284.26 370.04 292.66 380.62 299.73 370.19 299.96 370.35 292.68 381.09",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.28,
    y: 439.81,
    width: 165.15,
    height: 31.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.16,
    y: 391.25,
    width: 63.07,
    height: 32.88,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.98,
    y: 285.71,
    width: 7.69,
    height: 186.14,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.98,
    y: 282.69,
    width: 90.85,
    height: 6.04,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.14,
    y: 331.45,
    width: 90.85,
    height: 6.04,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.14,
    y: 344.15,
    width: 90.85,
    height: 6.04,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.14,357v114.9H157V357Zm29.53,64.72H81.31V398.6H95.67Zm0-31.06H81.31V367.54H95.67Zm21.83,31.62H103.15V399.16H117.5Zm0-31.62H103.15V367.54H117.5Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.25,
    y: 282.69,
    width: 44.72,
    height: 189.16,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.16,
    y: 244.19,
    width: 5.34,
    height: 52.52,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.13,
    y: 244.19,
    width: 5.34,
    height: 52.52,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.16,
    y: 244.18,
    width: 39.01,
    height: 4.42,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.48,
    y: 336.05,
    width: 5.12,
    height: 21.11,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.93,
    y: 336.05,
    width: 5.12,
    height: 21.11,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.12,325.1h88.95a.69.69,0,0,0,0-1.38H67.12a.69.69,0,0,0,0,1.38Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.74,288.36v43.35a.69.69,0,0,0,1.38,0V288.36a.69.69,0,0,0-1.38,0Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4,356.54c15-12.92,22.87-32.77,26-51.9a123.68,123.68,0,0,0,1.56-18.34.69.69,0,0,0-1.38,0c-.23,20.28-5.19,41.42-17.08,58.15a62,62,0,0,1-10,11.11c-.68.58.31,1.55,1,1Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.19,287.55a197.59,197.59,0,0,1-13.47,56.56q-2.85,7.22-6.29,14.16c-.4.8.79,1.5,1.19.7a201.47,201.47,0,0,0,17.84-54.84c1-5.49,1.68-11,2.12-16.58.07-.88-1.32-.88-1.39,0Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.13,
    y: 345.63,
    width: 4.67,
    height: 126.22,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.47,
    y: 345.63,
    width: 17.68,
    height: 4.56,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.14,
    y: 390.61,
    width: 17.91,
    height: 8.56,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.47,
    y: 464.9,
    width: 17.68,
    height: 6.95,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.57,347.92V466.77a.69.69,0,0,0,1.38,0V347.92a.69.69,0,0,0-1.38,0Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.62,347.92V466.77a.69.69,0,0,0,1.38,0V347.92a.69.69,0,0,0-1.38,0Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.73,471.08h-4.82V238.26h4.82Zm-4.51-.34h4.2V238.6h-4.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 317.2,
    width: 4.51,
    height: 1.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 319.36,
    width: 4.51,
    height: 1.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 322.02,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 324.18,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 326.34,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 328.5,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 330.66,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 332.31,
    width: 4.51,
    height: 1.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 334.98,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 336.63,
    width: 4.51,
    height: 1.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 339.29,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 341.45,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 343.61,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 345.77,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 347.93,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 350.09,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 351.75,
    width: 4.51,
    height: 1.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 354.41,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 356.57,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 358.23,
    width: 4.51,
    height: 1.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 360.89,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 363.05,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 365.21,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 367.37,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 369.53,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 371.18,
    width: 4.51,
    height: 1.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 373.34,
    width: 4.51,
    height: 1.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 376,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 378.16,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 380.32,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 382.48,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 384.64,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 386.8,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 388.46,
    width: 4.51,
    height: 1.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 391.12,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 392.78,
    width: 4.51,
    height: 1.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 395.44,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 397.1,
    width: 4.51,
    height: 1.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 399.76,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 401.92,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 404.08,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 406.24,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 408.4,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 410.05,
    width: 4.51,
    height: 1.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 412.72,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 414.37,
    width: 4.51,
    height: 1.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 417.03,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 419.19,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 421.35,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 423.51,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 425.67,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 427.83,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 429.99,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 432.15,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 433.81,
    width: 4.51,
    height: 1.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 436.47,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 438.63,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 440.79,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 442.95,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 445.11,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 447.27,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 449.43,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 451.59,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 453.24,
    width: 4.51,
    height: 1.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 455.9,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 458.06,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 460.22,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 462.38,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 464.54,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 466.7,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 315.18,
    width: 4.51,
    height: 1.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 313.67,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 311.66,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 309.65,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 307.64,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 305.62,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 303.61,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 301.6,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 299.08,
    width: 4.51,
    height: 1.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 297.57,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 295.05,
    width: 4.51,
    height: 1.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 293.54,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 291.53,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 289.52,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 287.51,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 285.49,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 283.48,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 281.47,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 279.45,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 277.44,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 274.92,
    width: 4.51,
    height: 1.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 273.42,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 271.4,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 269.39,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 267.38,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 265.36,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 263.35,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 261.34,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 259.32,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 256.81,
    width: 4.51,
    height: 1.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 255.3,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 253.29,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 251.27,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 249.26,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 247.25,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 245.23,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 243.22,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 241.21,
    width: 4.51,
    height: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.31,450.8a.46.46,0,0,1-.46-.46c0-31.41.06-69.76.13-106.86s.12-75.45.12-106.85a.46.46,0,0,1,.92,0c0,31.4-.06,69.76-.13,106.85s-.12,75.45-.12,106.86A.47.47,0,0,1,116.31,450.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.31,293.77a.46.46,0,0,1-.37-.21l-23.62-35a.54.54,0,0,1,.1-.7.43.43,0,0,1,.64.11l23.62,35a.54.54,0,0,1-.1.71A.47.47,0,0,1,116.31,293.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.31,275.14a.45.45,0,0,1-.37-.2L92.32,240a.54.54,0,0,1,.1-.7.44.44,0,0,1,.64.1l23.62,35a.54.54,0,0,1-.1.71A.46.46,0,0,1,116.31,275.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.31,313.5a.45.45,0,0,1-.37-.2l-23.62-35a.54.54,0,0,1,.1-.7.44.44,0,0,1,.64.1l23.62,35a.54.54,0,0,1-.1.71A.46.46,0,0,1,116.31,313.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.31,333.24a.45.45,0,0,1-.37-.2l-23.62-35a.54.54,0,0,1,.1-.7.43.43,0,0,1,.64.1l23.62,35a.53.53,0,0,1-.1.7A.41.41,0,0,1,116.31,333.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.31,353a.45.45,0,0,1-.37-.2l-23.62-35a.54.54,0,0,1,.1-.7.43.43,0,0,1,.64.1l23.62,35a.53.53,0,0,1-.1.7A.41.41,0,0,1,116.31,353Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.31,372.72a.45.45,0,0,1-.37-.2l-23.62-35a.54.54,0,0,1,.1-.7.43.43,0,0,1,.64.1l23.62,35a.53.53,0,0,1-.1.7A.41.41,0,0,1,116.31,372.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.31,392.46a.45.45,0,0,1-.37-.2l-23.62-35a.55.55,0,0,1,.1-.71.44.44,0,0,1,.64.11l23.62,35a.53.53,0,0,1-.1.7A.41.41,0,0,1,116.31,392.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.31,412.2a.44.44,0,0,1-.37-.21L92.32,377a.55.55,0,0,1,.1-.71.43.43,0,0,1,.64.11l23.62,35a.53.53,0,0,1-.1.7A.41.41,0,0,1,116.31,412.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.31,431.94a.44.44,0,0,1-.37-.21l-23.62-35a.55.55,0,0,1,.1-.71.43.43,0,0,1,.64.11l23.62,35a.54.54,0,0,1-.1.71A.47.47,0,0,1,116.31,431.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.06,450.44a.44.44,0,0,1-.36-.2L92.33,416.5a.53.53,0,0,1,.09-.71.44.44,0,0,1,.64.1l23.37,33.74a.55.55,0,0,1-.09.71A.48.48,0,0,1,116.06,450.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.31,471.41H92.47a.47.47,0,0,1-.45-.5V237.53a.46.46,0,1,1,.91,0v198a.53.53,0,0,1,.13.13l23.62,35a.55.55,0,0,1,0,.53A.46.46,0,0,1,116.31,471.41Zm-23.38-1H115.4L92.93,437.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.47,291a.41.41,0,0,1-.27-.1.52.52,0,0,1-.09-.7l24-35.07a.43.43,0,0,1,.64-.11.55.55,0,0,1,.09.71l-24,35.07A.43.43,0,0,1,92.47,291Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.47,272.14a.43.43,0,0,1-.27-.1.54.54,0,0,1-.1-.7l23.62-35.51a.43.43,0,0,1,.64-.12.54.54,0,0,1,.1.71L92.85,271.93A.44.44,0,0,1,92.47,272.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.47,311.09a.5.5,0,0,1-.27-.1.54.54,0,0,1-.1-.7l23.62-35.52a.44.44,0,0,1,.64-.11.54.54,0,0,1,.1.71L92.85,310.88A.47.47,0,0,1,92.47,311.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.47,331.13a.43.43,0,0,1-.27-.1.54.54,0,0,1-.1-.7l24-36a.44.44,0,0,1,.64-.11.54.54,0,0,1,.1.71l-24,36A.44.44,0,0,1,92.47,331.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.47,351.17a.43.43,0,0,1-.27-.1.54.54,0,0,1-.1-.7l23.62-35.51a.43.43,0,0,1,.64-.12.54.54,0,0,1,.1.71L92.85,351A.44.44,0,0,1,92.47,351.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.47,371.21a.43.43,0,0,1-.27-.1.54.54,0,0,1-.1-.7l23.62-35.51a.42.42,0,0,1,.64-.11.52.52,0,0,1,.1.7L92.85,371A.44.44,0,0,1,92.47,371.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.47,391.25a.43.43,0,0,1-.27-.1.53.53,0,0,1-.1-.7l23.62-35.51a.43.43,0,0,1,.64-.11.52.52,0,0,1,.1.7L92.85,391A.44.44,0,0,1,92.47,391.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.47,411.29a.48.48,0,0,1-.27-.09.55.55,0,0,1-.1-.71L115.72,375a.43.43,0,0,1,.64-.11.53.53,0,0,1,.1.7L92.85,411.08A.44.44,0,0,1,92.47,411.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.47,431.33a.48.48,0,0,1-.27-.09.55.55,0,0,1-.1-.71L115.72,395a.43.43,0,0,1,.64-.11.53.53,0,0,1,.1.7L92.85,431.13A.46.46,0,0,1,92.47,431.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.47,451.37a.48.48,0,0,1-.27-.09.55.55,0,0,1-.1-.71l23.62-35.51a.43.43,0,0,1,.64-.11.53.53,0,0,1,.1.7L92.85,451.17A.46.46,0,0,1,92.47,451.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.47,471.41a.48.48,0,0,1-.27-.09.54.54,0,0,1-.1-.7l23.62-35.52a.44.44,0,0,1,.64-.11.53.53,0,0,1,.1.7L92.85,471.21A.46.46,0,0,1,92.47,471.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.29,204.76l-.81-.92,11.28-10.07H123c24,0,48.48,0,73,.08s48.93.08,72.94.08v1.23c-24,0-48.48,0-72.94-.08s-48.78-.08-72.72-.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.42,208a.63.63,0,0,1-.46-.2A.62.62,0,0,1,115,207l14.48-12.86a.6.6,0,0,1,.82,0l13.36,12.47,12.9-12.47a.61.61,0,0,1,.83,0l14.18,12.49,13-12.48a.6.6,0,0,1,.83,0l14.07,12.49,13.37-12.48a.61.61,0,0,1,.82,0L228,206.58l12.8-12.47a.62.62,0,0,1,.85,0l13.59,12.48,13.25-12.47a.63.63,0,0,1,.83,0L284,207a.61.61,0,0,1-.81.92l-14.29-12.5-13.26,12.49a.62.62,0,0,1-.84,0l-13.59-12.47-12.79,12.46a.61.61,0,0,1-.83,0l-14.29-12.5-13.38,12.49a.61.61,0,0,1-.82,0L185,195.38l-13,12.47a.62.62,0,0,1-.83,0L157,195.38,144.1,207.85a.61.61,0,0,1-.84,0l-13.37-12.49-14.07,12.5A.6.6,0,0,1,115.42,208Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.53,
    y: 196.48,
    width: 24.66,
    height: 29.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.48,225.51c-.18,0-.32-6.5-.32-14.52s.14-14.51.32-14.51.32,6.5.32,14.51S35.66,225.51,35.48,225.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,225.51c-.18,0-.32-6.5-.32-14.52s.14-14.51.32-14.51.32,6.5.32,14.51S45.15,225.51,45,225.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.9,208.24H25.2V204H283.9Zm-258.08-.62H283.29v-3H25.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.88,208.24a.27.27,0,0,1-.17-.06L98,199a.31.31,0,0,1-.08-.43.3.3,0,0,1,.42-.08l13.68,9.24a.31.31,0,0,1,.09.42A.31.31,0,0,1,111.88,208.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.88,208.17a.3.3,0,0,1-.3-.26l-1.17-9.11-13.49,9.32a.32.32,0,0,1-.34,0,.3.3,0,0,1-.14-.3l5-39.26v0l.63-4.91v0l.73-5.72v0l.6-4.74a.3.3,0,0,1,.31-.27h1.14a.3.3,0,0,1,.3.27l2.59,20.16v0l.65,5v0l.68,5.28s0,0,0,.06a.38.38,0,0,1,0,.15l3.07,23.94a.3.3,0,0,1-.27.34ZM99.29,190.33l-2.16,16.9,12.34-8.53-10.9.24h0a.31.31,0,0,1-.29-.2.33.33,0,0,1,.1-.35l10.26-8.06Zm10.06.2-9.88,7.78,10.85-.24Zm-9.26-.82h9.16l-.69-5.36Zm0-5.58-.67,5.29,8.35-5.29Zm.79-.61h7.58l-.59-4.57Zm-.1-4.79-.57,4.49,6.88-4.49Zm.69-.61h6.3l-.54-4.21Zm0-4.46-.53,4.12,5.63-4.12Zm.6-.61h5.09l-.49-3.82Zm0-4.15-.48,3.74,4.46-3.7Zm.41-.6,4.06,0-.5-3.94Zm.21-4.32-.47,3.69,3.35-3.67Zm.24-.61,3,0-.58-4.53Zm.5-5.14-.49,3.82,2-3.86Zm.61-4.75-.53,4.13,1.65,0-.52-4.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.24,164a.3.3,0,0,1-.27-.16l-3.08-5.81a.31.31,0,0,1,.12-.41.31.31,0,0,1,.42.13l3.08,5.8a.3.3,0,0,1-.13.41A.23.23,0,0,1,106.24,164Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.87,169a.33.33,0,0,1-.23-.09l-4.46-4.9a.31.31,0,1,1,.46-.42l4.45,4.9a.31.31,0,0,1,0,.44A.29.29,0,0,1,106.87,169Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.46,173.73a.37.37,0,0,1-.2-.07l-5.68-4.72a.31.31,0,0,1,.39-.47l5.68,4.72a.3.3,0,0,1,0,.43A.31.31,0,0,1,107.46,173.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.1,178.8a.32.32,0,0,1-.18-.06L101,173.67a.31.31,0,0,1,.36-.5l6.94,5.07a.31.31,0,0,1-.19.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.79,184.19a.34.34,0,0,1-.17-.05l-8.27-5.39a.31.31,0,1,1,.34-.51l8.27,5.39a.29.29,0,0,1,.08.42A.29.29,0,0,1,108.79,184.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.59,190.39a.3.3,0,0,1-.16,0l-9.78-6.2a.3.3,0,0,1-.1-.42.31.31,0,0,1,.42-.09l9.78,6.19a.31.31,0,0,1,.1.43A.31.31,0,0,1,109.59,190.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.49,198.68a.28.28,0,0,1-.18-.06l-11.37-8.29a.31.31,0,0,1-.07-.43.32.32,0,0,1,.43-.07l11.37,8.3a.31.31,0,0,1,.06.43A.3.3,0,0,1,110.49,198.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.31,220.21a.3.3,0,0,1-.3-.31V152.39a.3.3,0,0,1,.3-.31.31.31,0,0,1,.31.31V219.9A.31.31,0,0,1,104.31,220.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.69,
    y: 207.93,
    width: 6.96,
    height: 23.64,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.12,
    y: 219.44,
    width: 18.76,
    height: 12.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.2,
    y: 222.06,
    width: 5.89,
    height: 9.81,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.53,
    y: 235.6,
    width: 30.13,
    height: 4.41,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.14,
    y: 231.33,
    width: 24.26,
    height: 2.45,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.43,
    y: 233.35,
    width: 21.73,
    height: 2.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.46,
    y: 296.98,
    width: 23.97,
    height: 2.45,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.46,
    y: 350.09,
    width: 23.85,
    height: 2.45,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.46,
    y: 406.01,
    width: 23.85,
    height: 2.45,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.38 199.56 29.06 199.03 104.36 152.57 104.5 152.61 227.29 194.21 227.09 194.79 104.44 153.24 29.38 199.56",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.83 204.25 95.52 204.25 95.52 199.45 25.66 199.45 25.66 204.25 25.36 204.25 25.36 199.14 95.83 199.14 95.83 204.25",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.06,
    y: 199.3,
    width: 0.31,
    height: 4.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.23,
    y: 199.3,
    width: 0.31,
    height: 4.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.4,
    y: 199.3,
    width: 0.31,
    height: 4.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.57,
    y: 199.3,
    width: 0.31,
    height: 4.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.73,
    y: 199.3,
    width: 0.31,
    height: 4.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.9,
    y: 199.3,
    width: 0.31,
    height: 4.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.07,
    y: 199.3,
    width: 0.31,
    height: 4.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.24,
    y: 199.3,
    width: 0.31,
    height: 4.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.41,
    y: 199.3,
    width: 0.31,
    height: 4.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.58,
    y: 199.3,
    width: 0.31,
    height: 4.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.74,
    y: 199.3,
    width: 0.31,
    height: 4.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.91,
    y: 199.3,
    width: 0.31,
    height: 4.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.08,
    y: 199.3,
    width: 0.31,
    height: 4.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.25,
    y: 199.3,
    width: 0.31,
    height: 4.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.42,
    y: 199.3,
    width: 0.31,
    height: 4.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.58,
    y: 199.3,
    width: 0.31,
    height: 4.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.75,
    y: 199.3,
    width: 0.31,
    height: 4.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.92,
    y: 199.3,
    width: 0.31,
    height: 4.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.09,
    y: 199.3,
    width: 0.31,
    height: 4.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.26,
    y: 199.3,
    width: 0.31,
    height: 4.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.42,
    y: 199.3,
    width: 0.31,
    height: 4.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.32,
    y: 204.3,
    width: 6.41,
    height: 3.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.99,
    y: 204.3,
    width: 6.41,
    height: 3.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.12,
    y: 204.3,
    width: 6.41,
    height: 3.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.52,
    y: 204.3,
    width: 6.41,
    height: 3.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.92,
    y: 204.3,
    width: 6.41,
    height: 3.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.32,
    y: 204.3,
    width: 6.41,
    height: 3.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.73,
    y: 204.3,
    width: 6.41,
    height: 3.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.13,
    y: 204.3,
    width: 6.41,
    height: 3.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.53,
    y: 204.3,
    width: 6.41,
    height: 3.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.93,
    y: 204.3,
    width: 6.41,
    height: 3.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.33,
    y: 204.3,
    width: 6.41,
    height: 3.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.28,
    y: 204.3,
    width: 6.41,
    height: 3.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.24,
    y: 204.3,
    width: 6.41,
    height: 3.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.21,
    y: 204.3,
    width: 6.41,
    height: 3.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.39,
    y: 175.91,
    width: 78.81,
    height: 0.61,
    transform: "translate(-89.62 75.47) rotate(-35.86)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.04,
    cy: 209.19,
    r: 2.68,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.07,
    cy: 209.19,
    r: 2.68,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.89,
    y: 203.58,
    width: 15.15,
    height: 4.84,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.28,
    y: 151.82,
    width: 2.25,
    height: 2.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.14,154.69h-3.48v-3.48h3.48Zm-2.25-1.23h1v-1h-1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.2,207.87a3.48,3.48,0,0,1,2.87,3.65v7.92H101.44l.2-11.5Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.2,207.87a3.57,3.57,0,0,1-.91.08l-2.54.09-9.11.17.27-.27c0,3.38-.09,7.3-.15,11.51l-.32-.33h2.28l13.35,0-.27.27c0-1.93,0-3.72,0-5.32q0-1.19,0-2.22a4.82,4.82,0,0,0-.21-1.8,3.32,3.32,0,0,0-1.62-1.87c-.54-.27-.86-.33-.85-.36a1.71,1.71,0,0,1,.92.21A3.41,3.41,0,0,1,117,210a5.08,5.08,0,0,1,.28,1.91q0,1,0,2.22c0,1.6,0,3.39,0,5.32v.28h-.28l-13.35,0h-2.6v-.32c.09-4.21.17-8.13.24-11.51v-.27h.26l9.12.06,2.54.06A3.36,3.36,0,0,1,114.2,207.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,211c.12.13-1.17,1.38-2.88,2.79s-3.17,2.43-3.29,2.3,1.18-1.39,2.89-2.8S111.86,210.84,112,211Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.43,213.3c.11.13-.79,1.09-2,2.13s-2.32,1.77-2.43,1.64.79-1.09,2-2.13S112.31,213.17,112.43,213.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.89,231.87c-.18,0-.32-5.29-.32-11.81s.14-11.82.32-11.82.32,5.29.32,11.82S95.06,231.87,94.89,231.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.56,231.87c0,.18-5.56.32-12.42.32s-12.42-.14-12.42-.32,5.56-.32,12.42-.32S116.56,231.7,116.56,231.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.56,233.77c0,.18-5.46.32-12.21.32s-12.21-.14-12.21-.32,5.47-.31,12.21-.31S116.56,233.6,116.56,233.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.56,235.6c0,.18-5.46.32-12.21.32s-12.21-.14-12.21-.32,5.47-.32,12.21-.32S116.56,235.43,116.56,235.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.93,
    y: 192.89,
    width: 8.66,
    height: 1.65,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.39,471.41c0,.15-105.84.26-236.38.26s-236.4-.11-236.4-.26,105.82-.26,236.4-.26S486.39,471.27,486.39,471.41Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--construction-crane-1--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.21,459.24h-6.88V146.87h6.88Zm-6.63-.25H190V147.12h-6.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 253.15,
    width: 6.63,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 256.04,
    width: 6.63,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 259.32,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 262.22,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 265.12,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 268.02,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 270.92,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 273.44,
    width: 6.63,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 276.71,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 279.24,
    width: 6.63,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 282.51,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 285.41,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 288.31,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 291.21,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 294.11,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 297.01,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 299.53,
    width: 6.63,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 302.81,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 305.71,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 308.23,
    width: 6.63,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 311.5,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 314.4,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 317.3,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 320.2,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 323.1,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 325.62,
    width: 6.63,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 328.52,
    width: 6.63,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 331.8,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 334.7,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 337.6,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 340.49,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 343.39,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 346.29,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 348.82,
    width: 6.63,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 352.09,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 354.62,
    width: 6.63,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 357.89,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 360.41,
    width: 6.63,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 363.69,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 366.59,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 369.49,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 372.39,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 375.28,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 377.81,
    width: 6.63,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 381.08,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 383.61,
    width: 6.63,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 386.88,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 389.78,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 392.68,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 395.58,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 398.48,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 401.38,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 404.28,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 407.18,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 409.7,
    width: 6.63,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 412.97,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 415.87,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 418.77,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 421.67,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 424.57,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 427.47,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 430.37,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 433.27,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 435.79,
    width: 6.63,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 439.07,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 441.96,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 444.86,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 447.76,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 450.66,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 453.56,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 250.44,
    width: 6.63,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 248.12,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 245.41,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 242.71,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 240.01,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 237.31,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 234.6,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 231.9,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 228.82,
    width: 6.63,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 226.5,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 223.42,
    width: 6.63,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 221.09,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 218.39,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 215.69,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 212.98,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 210.28,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 207.58,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 204.88,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 202.17,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 199.47,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 196.39,
    width: 6.63,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 194.07,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 191.37,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 188.66,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 185.96,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 183.26,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 180.56,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 177.85,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 175.15,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 172.07,
    width: 6.63,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 169.75,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 167.04,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 164.34,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 161.64,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 158.94,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 156.23,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 153.53,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.45,
    y: 150.83,
    width: 6.63,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.93,459.49a.38.38,0,0,1-.37-.38c0-46.2.09-102.63.18-157.2s.19-111,.19-157.2a.38.38,0,1,1,.75,0c0,46.2-.09,102.63-.19,157.2s-.18,111-.18,157.2A.38.38,0,0,1,202.93,459.49Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.93,221a.38.38,0,0,1-.3-.15l-34.74-47a.38.38,0,0,1,.08-.53.39.39,0,0,1,.53.08l34.74,47a.38.38,0,0,1-.08.52A.4.4,0,0,1,202.93,221Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.93,196a.38.38,0,0,1-.3-.15l-34.74-47a.38.38,0,0,1,.08-.53.39.39,0,0,1,.53.08l34.74,47a.38.38,0,0,1-.08.52A.4.4,0,0,1,202.93,196Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.93,247.49a.38.38,0,0,1-.3-.15l-34.74-47a.38.38,0,0,1,.08-.53.39.39,0,0,1,.53.08l34.74,47a.38.38,0,0,1-.08.52A.4.4,0,0,1,202.93,247.49Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.93,274a.38.38,0,0,1-.3-.15l-34.74-47a.38.38,0,0,1,.08-.53.39.39,0,0,1,.53.08l34.74,47a.37.37,0,0,1-.31.6Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.93,300.49a.42.42,0,0,1-.3-.15l-34.74-47a.38.38,0,0,1,.08-.53.39.39,0,0,1,.53.08l34.74,47a.38.38,0,0,1-.08.52A.4.4,0,0,1,202.93,300.49Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.93,327a.42.42,0,0,1-.3-.15l-34.74-47a.38.38,0,0,1,.08-.53.39.39,0,0,1,.53.08l34.74,47a.38.38,0,0,1-.08.52A.4.4,0,0,1,202.93,327Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.93,353.49a.42.42,0,0,1-.3-.15l-34.74-47a.38.38,0,0,1,.08-.53.39.39,0,0,1,.53.08l34.74,47a.38.38,0,0,1-.08.52A.4.4,0,0,1,202.93,353.49Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.93,380a.42.42,0,0,1-.3-.15l-34.74-47a.38.38,0,0,1,.08-.53.39.39,0,0,1,.53.08l34.74,47a.38.38,0,0,1-.08.52A.4.4,0,0,1,202.93,380Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.93,406.49a.42.42,0,0,1-.3-.15l-34.74-47a.38.38,0,0,1,.08-.53.39.39,0,0,1,.53.08l34.74,47a.38.38,0,0,1-.08.52A.4.4,0,0,1,202.93,406.49Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.57,431.33a.42.42,0,0,1-.3-.15l-34.37-45.3a.37.37,0,1,1,.59-.45l34.38,45.29a.39.39,0,0,1-.07.53A.4.4,0,0,1,202.57,431.33Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.93,459.49H167.87a.37.37,0,0,1-.37-.38V145.79a.37.37,0,0,1,.37-.38.38.38,0,0,1,.38.38v266a.47.47,0,0,1,.25.15l34.74,47a.39.39,0,0,1,0,.39A.37.37,0,0,1,202.93,459.49Zm-34.68-.75h33.94l-33.94-45.88Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.87,217.34a.35.35,0,0,1-.22-.08.37.37,0,0,1-.08-.52l35.25-47.09a.37.37,0,0,1,.52-.08.38.38,0,0,1,.08.53l-35.25,47.08A.38.38,0,0,1,167.87,217.34Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.87,192a.36.36,0,0,1-.22-.07.37.37,0,0,1-.08-.52l34.74-47.68a.37.37,0,1,1,.6.44L168.17,191.8A.36.36,0,0,1,167.87,192Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.87,244.24a.36.36,0,0,1-.22-.07.37.37,0,0,1-.08-.52L202.31,196a.37.37,0,1,1,.6.44l-34.74,47.68A.36.36,0,0,1,167.87,244.24Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.87,271.15a.38.38,0,0,1-.3-.6l35.25-48.37a.37.37,0,0,1,.52-.09.38.38,0,0,1,.08.53L168.17,271A.37.37,0,0,1,167.87,271.15Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.87,298.05a.36.36,0,0,1-.22-.07.37.37,0,0,1-.08-.52l34.74-47.68a.37.37,0,1,1,.6.44L168.17,297.9A.36.36,0,0,1,167.87,298.05Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.87,325a.44.44,0,0,1-.22-.07.38.38,0,0,1-.08-.53l34.74-47.68a.38.38,0,0,1,.52-.08.37.37,0,0,1,.08.53L168.17,324.8A.37.37,0,0,1,167.87,325Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.87,351.86a.36.36,0,0,1-.22-.07.37.37,0,0,1-.08-.52l34.74-47.68a.37.37,0,0,1,.52-.08.36.36,0,0,1,.08.52l-34.74,47.68A.36.36,0,0,1,167.87,351.86Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.87,378.77a.36.36,0,0,1-.22-.07.38.38,0,0,1-.08-.53l34.74-47.67a.37.37,0,1,1,.6.44l-34.74,47.68A.36.36,0,0,1,167.87,378.77Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.87,405.68a.38.38,0,0,1-.3-.6l34.74-47.68a.37.37,0,0,1,.52-.08.36.36,0,0,1,.08.52l-34.74,47.68A.37.37,0,0,1,167.87,405.68Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.87,432.58a.36.36,0,0,1-.22-.07.37.37,0,0,1-.08-.52l34.74-47.68a.37.37,0,1,1,.6.44l-34.74,47.68A.36.36,0,0,1,167.87,432.58Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.87,459.49a.44.44,0,0,1-.22-.07.38.38,0,0,1-.08-.53l34.74-47.68a.38.38,0,0,1,.52-.08.37.37,0,0,1,.08.53l-34.74,47.67A.37.37,0,0,1,167.87,459.49Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.33,97.88l-.67-.75,16.91-15.06h.19c35.33,0,71.93.05,107.32.11s72,.12,107.32.12v1c-35.33,0-71.93-.06-107.32-.12s-71.86-.11-107.13-.11Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.6,102.93a.52.52,0,0,1-.38-.17.51.51,0,0,1,.05-.71l22.32-19.63a.5.5,0,0,1,.67,0L243.19,101l19.26-18.6a.51.51,0,0,1,.68,0l21.12,18.63,19.44-18.61a.49.49,0,0,1,.67,0l21,18.63,19.95-18.62a.5.5,0,0,1,.67,0l21.29,18.63,19.09-18.61a.5.5,0,0,1,.69,0L407.29,101l19.76-18.61a.52.52,0,0,1,.68,0l21.64,18.93a.5.5,0,0,1-.66.75l-21.3-18.63-19.78,18.62a.5.5,0,0,1-.68,0l-20.27-18.6L367.6,102.08a.5.5,0,0,1-.68,0l-21.3-18.63-19.95,18.62a.49.49,0,0,1-.67,0L304,83.48l-19.43,18.61a.51.51,0,0,1-.68,0L262.81,83.48l-19.26,18.6a.5.5,0,0,1-.69,0l-20-18.62-22,19.33A.5.5,0,0,1,200.6,102.93Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.32,
    y: 85.64,
    width: 36.28,
    height: 42.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,128.35c-.14,0-.26-9.56-.26-21.35s.12-21.36.26-21.36.26,9.56.26,21.36S84.17,128.35,84,128.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,128.35c-.14,0-.26-9.56-.26-21.35s.12-21.36.26-21.36.26,9.56.26,21.36S98.13,128.35,98,128.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.29,102.74H69.1V96.9H449.29Zm-379.69-.5H448.79V97.4H69.6Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.42,102.74a.27.27,0,0,1-.14,0L176.15,89.11a.25.25,0,0,1-.06-.35.24.24,0,0,1,.34-.06l20.13,13.58a.25.25,0,0,1,.07.35A.26.26,0,0,1,196.42,102.74Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.42,102.65a.24.24,0,0,1-.24-.22l-1.76-13.72L174.29,102.6a.25.25,0,0,1-.39-.23l7.38-57.77v0l.92-7.23h0l2-15.43a.24.24,0,0,1,.24-.22h1.68a.25.25,0,0,1,.25.22l.88,6.88v0l2,15.83h0l1.84,14.39h0l1,7.82a.21.21,0,0,1,0,.07.22.22,0,0,1,0,.16l4.52,35.26a.25.25,0,0,1-.21.28ZM176.1,89.08l-1.63,12.79,19.1-13.19Zm16.75-12.57-16,12,17.54-.4Zm-15.13-.12-1.53,12,16-12Zm.67-.5h14.38l-1.08-8.43Zm.5-8.62-1.07,8.39,13.23-8.39Zm.65-.5H191.6l-.93-7.25Zm.36-7.43-.92,7.2L190,59.34Zm.57-.5h10.11l-.86-6.76Zm.38-7L180,58.57l9.14-6.69Zm.5-.5h8.28l-.8-6.21Zm.4-6.51L181,51.06l7.37-6.13Zm.34-.49,6.64,0L187.91,38Zm.58-6.75-.79,6.24,5.64-6.21Zm.2-.5,4.93,0-1-7.51Zm.88-8-.88,6.87,3.69-6.95Zm.89-7-.82,6.48,2.88-.07-.82-6.41Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.12,37.72a.26.26,0,0,1-.22-.13l-4.53-8.54a.25.25,0,0,1,.1-.34.25.25,0,0,1,.34.11l4.53,8.53a.25.25,0,0,1-.1.34Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.05,45a.25.25,0,0,1-.19-.09l-6.56-7.2a.26.26,0,0,1,0-.36.25.25,0,0,1,.35,0l6.56,7.21a.25.25,0,0,1,0,.35A.28.28,0,0,1,189.05,45Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.91,52a.27.27,0,0,1-.16-.06L181.4,45a.25.25,0,1,1,.31-.38l8.36,6.94a.24.24,0,0,1,0,.35A.25.25,0,0,1,189.91,52Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.87,59.43a.2.2,0,0,1-.15,0l-10.2-7.46a.25.25,0,1,1,.29-.4L191,59a.25.25,0,0,1,.06.35A.25.25,0,0,1,190.87,59.43Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.87,67.36a.22.22,0,0,1-.13,0l-12.17-7.93a.25.25,0,0,1-.07-.35.25.25,0,0,1,.34-.07L192,66.91a.24.24,0,0,1,.07.34A.26.26,0,0,1,191.87,67.36Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.05,76.48a.2.2,0,0,1-.13,0l-14.39-9.11a.26.26,0,0,1-.08-.35.25.25,0,0,1,.34-.08L193.18,76a.25.25,0,0,1,.08.35A.26.26,0,0,1,193.05,76.48Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.4,88.66a.24.24,0,0,1-.14,0L177.5,76.43a.23.23,0,0,1-.06-.34.25.25,0,0,1,.35-.06l16.76,12.18a.25.25,0,0,1,.06.35A.28.28,0,0,1,194.4,88.66Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.29,120.35a.25.25,0,0,1-.25-.25V20.78a.25.25,0,0,1,.25-.25.25.25,0,0,1,.25.25V120.1A.25.25,0,0,1,185.29,120.35Z",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.12,
    y: 102.49,
    width: 10.23,
    height: 34.79,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.64,
    y: 119.43,
    width: 27.6,
    height: 18.29,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.05,
    y: 123.28,
    width: 8.66,
    height: 14.44,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.53,
    y: 143.2,
    width: 44.32,
    height: 6.49,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.38,
    y: 136.91,
    width: 35.69,
    height: 3.6,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.28,
    y: 139.89,
    width: 31.97,
    height: 3.31,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.85,
    y: 234.3,
    width: 35.27,
    height: 2,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.85,
    y: 312.43,
    width: 35.08,
    height: 2,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.85,
    y: 394.7,
    width: 35.08,
    height: 2,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.94 90 74.68 89.58 185.39 21.26 185.5 21.3 366.14 82.49 365.98 82.97 185.45 21.81 74.94 90",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.7 97.08 172.45 97.08 172.45 89.91 69.48 89.91 69.48 97.08 69.23 97.08 69.23 89.66 172.7 89.66 172.7 97.08",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.68,
    y: 89.79,
    width: 0.25,
    height: 7.1,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.34,
    y: 89.79,
    width: 0.25,
    height: 7.1,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 89.79,
    width: 0.25,
    height: 7.1,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.66,
    y: 89.79,
    width: 0.25,
    height: 7.1,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.33,
    y: 89.79,
    width: 0.25,
    height: 7.1,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.99,
    y: 89.79,
    width: 0.25,
    height: 7.1,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.65,
    y: 89.79,
    width: 0.25,
    height: 7.1,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.31,
    y: 89.79,
    width: 0.25,
    height: 7.1,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.97,
    y: 89.79,
    width: 0.25,
    height: 7.1,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.63,
    y: 89.79,
    width: 0.25,
    height: 7.1,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.29,
    y: 89.79,
    width: 0.25,
    height: 7.1,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.95,
    y: 89.79,
    width: 0.25,
    height: 7.1,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.61,
    y: 89.79,
    width: 0.25,
    height: 7.1,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.27,
    y: 89.79,
    width: 0.25,
    height: 7.1,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.93,
    y: 89.79,
    width: 0.25,
    height: 7.1,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.59,
    y: 89.79,
    width: 0.25,
    height: 7.1,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.25,
    y: 89.79,
    width: 0.25,
    height: 7.1,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.91,
    y: 89.79,
    width: 0.25,
    height: 7.1,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.58,
    y: 89.79,
    width: 0.25,
    height: 7.1,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.24,
    y: 89.79,
    width: 0.25,
    height: 7.1,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.9,
    y: 89.79,
    width: 0.25,
    height: 7.1,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.22,
    y: 97.15,
    width: 9.44,
    height: 5.34,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.33,
    y: 97.15,
    width: 9.44,
    height: 5.34,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.48,
    y: 97.15,
    width: 9.44,
    height: 5.34,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.55,
    y: 97.15,
    width: 9.44,
    height: 5.34,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.63,
    y: 97.15,
    width: 9.44,
    height: 5.34,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.7,
    y: 97.15,
    width: 9.44,
    height: 5.34,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.77,
    y: 97.15,
    width: 9.44,
    height: 5.34,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.84,
    y: 97.15,
    width: 9.44,
    height: 5.34,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.91,
    y: 97.15,
    width: 9.44,
    height: 5.34,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.98,
    y: 97.15,
    width: 9.44,
    height: 5.34,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.06,
    y: 97.15,
    width: 9.44,
    height: 5.34,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.57,
    y: 97.15,
    width: 9.44,
    height: 5.34,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.92,
    y: 97.15,
    width: 9.44,
    height: 5.34,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.26,
    y: 97.15,
    width: 9.44,
    height: 5.34,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.47,
    y: 55.58,
    width: 115.94,
    height: 0.5,
    transform: "translate(-6.65 91.11) rotate(-35.86)",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 449.7,
    cy: 104.35,
    r: 3.94,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 433.55,
    cy: 104.35,
    r: 3.94,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.4,
    y: 96.09,
    width: 22.29,
    height: 7.12,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.7,103.22a2.09,2.09,0,0,1,0-.52c0-.37,0-.84,0-1.42,0-1.27-.06-3-.09-5.19l.17.17c-5.3.06-13.33.09-22.29.09.11-.11-.27.26.25-.26h0v7.1l-.26-.26c6.36,0,11.89.07,15.87.12l4.69.07,1.27,0,.47,0a1.93,1.93,0,0,1-.41,0l-1.22,0-4.62.07c-4,.05-9.58.11-16.05.12h-.25V99.74c0-.6,0-1.2,0-1.81V96.12h0c.52-.52.15-.14.27-.26,9,0,17,0,22.29.1h.17v.16c0,2.21-.07,4-.09,5.3,0,.55,0,1,0,1.38A2.42,2.42,0,0,1,449.7,103.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.52,
    y: 456.23,
    width: 56.39,
    height: 15.19,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.52,
    y: 461.87,
    width: 56.39,
    height: 3.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.52 461.87 158.04 465.58 160.94 465.58 159.25 461.87 156.52 461.87",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.23 461.87 163.75 465.58 166.64 465.58 164.95 461.87 162.23 461.87",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.93 461.87 169.45 465.58 172.35 465.58 170.66 461.87 167.93 461.87",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.64 461.87 175.16 465.58 178.05 465.58 176.36 461.87 173.64 461.87",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.34 461.87 180.86 465.58 183.76 465.58 182.07 461.87 179.34 461.87",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.05 461.87 186.57 465.58 189.47 465.58 187.77 461.87 185.05 461.87",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.76 461.87 192.27 465.58 195.17 465.58 193.48 461.87 190.76 461.87",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.46 461.87 197.98 465.58 200.88 465.58 199.19 461.87 196.46 461.87",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.17 461.87 203.68 465.58 206.58 465.58 204.89 461.87 202.17 461.87",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.87 461.87 209.39 465.58 212.29 465.58 210.6 461.87 207.87 461.87",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.29,461.92c0,.14-12.73.26-28.43.26s-28.43-.12-28.43-.26,12.73-.26,28.43-.26S213.29,461.77,213.29,461.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.29,465.79c0,.14-12.73.26-28.43.26s-28.43-.12-28.43-.26,12.73-.26,28.43-.26S213.29,465.64,213.29,465.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.76,
    y: 19.95,
    width: 3.31,
    height: 3.31,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.23,
    y: 137.17,
    width: 0.5,
    height: 45.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.87,
    cy: 107.57,
    r: 3.94,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.69,
    cy: 107.57,
    r: 3.94,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.43,
    cy: 104.65,
    r: 2.53,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.28,126.9a75.38,75.38,0,0,1-.26-8.79,75.63,75.63,0,0,1,.26-8.8,73.07,73.07,0,0,1,.26,8.8A72.83,72.83,0,0,1,317.28,126.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.27,126.9a72.83,72.83,0,0,1-.26-8.79,73.07,73.07,0,0,1,.26-8.8,75.63,75.63,0,0,1,.26,8.8A75.38,75.38,0,0,1,328.27,126.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.12,125.22c0,.25,3.1,14.27,3.1,14.27h8.31l3-14.27-7.21-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.2,
    y: 185.92,
    width: 37.81,
    height: 23.29,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.19,
    y: 208.43,
    width: 43.45,
    height: 1.59,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.19,
    y: 211.99,
    width: 43.45,
    height: 1.59,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.95,
    y: 209.22,
    width: 2.24,
    height: 3.57,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.66,
    y: 209.22,
    width: 2.24,
    height: 3.57,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.38,
    y: 209.22,
    width: 2.24,
    height: 3.57,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.09,
    y: 209.22,
    width: 2.24,
    height: 3.57,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.81,
    y: 209.22,
    width: 2.24,
    height: 3.57,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.53,
    y: 209.22,
    width: 2.24,
    height: 3.57,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.16,208.23c0,.15-9.56.26-21.37.26s-21.37-.11-21.37-.26S310,208,321.79,208,343.16,208.09,343.16,208.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.69,
    y: 101.12,
    width: 24.12,
    height: 6.45,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.81,107.57a3.09,3.09,0,0,1,0-.46l0-1.28c0-1.16-.05-2.74-.09-4.71l.16.16c-5.5.06-14.26.1-24.12.1.12-.11-.26.26.26-.26h0v6.44l-.26-.26c6.84,0,12.83.07,17.14.12l5.09.07,1.39,0,.5,0a2.23,2.23,0,0,1-.44,0l-1.33,0-5,.08c-4.3.05-10.37.1-17.32.11h-.25v-.25c0-1,0-2.1,0-3.17v-3.27h0l.26-.26c9.86,0,18.62,0,24.12.1H334v.16c0,2-.07,3.62-.09,4.8,0,.5,0,.91,0,1.24A1.93,1.93,0,0,1,333.81,107.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.82,
    y: 182.89,
    width: 5.69,
    height: 30.69,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.83,102.4a5.12,5.12,0,0,1,4.22,5.38v11.65h-23l.29-16.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.83,102.4l-.34,0-1,0-3.74.08-13.4.17.22-.21c-.08,4.94-.16,10.72-.26,16.92l-.25-.26h3.35l19.63,0-.22.23c0-2.87,0-5.5,0-7.84,0-1.16,0-2.25,0-3.26a7.13,7.13,0,0,0-.33-2.69,4.92,4.92,0,0,0-2.47-2.76,11.44,11.44,0,0,0-1.27-.48.94.94,0,0,1,.35,0,5.61,5.61,0,0,1,1,.32,5,5,0,0,1,2.66,2.79,7.46,7.46,0,0,1,.39,2.78c0,1,0,2.1,0,3.26,0,2.34,0,5,0,7.84v.22h-.23l-19.63,0H180.8v-.27c.12-6.2.23-12,.32-16.92v-.22h.21l13.42,0,3.74,0,1,0A1.18,1.18,0,0,1,199.83,102.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.56,107a33.76,33.76,0,0,1-4.38,4,33.89,33.89,0,0,1-4.7,3.54,34,34,0,0,1,4.37-3.95A33.61,33.61,0,0,1,196.56,107Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.22,110.39a17.44,17.44,0,0,1-3.09,3,17.79,17.79,0,0,1-3.43,2.57,17.44,17.44,0,0,1,3.09-3A17.79,17.79,0,0,1,197.22,110.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.42,137.71c-.14,0-.26-7.78-.26-17.38s.12-17.38.26-17.38.26,7.78.26,17.38S171.56,137.71,171.42,137.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.31,137.71c0,.15-8.18.26-18.27.26s-18.28-.11-18.28-.26,8.18-.26,18.28-.26S203.31,137.57,203.31,137.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.31,140.51c0,.14-8,.26-18,.26s-18-.12-18-.26,8-.26,18-.26S203.31,140.37,203.31,140.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.31,143.2c0,.14-8,.26-18,.26s-18-.12-18-.26,8-.26,18-.26S203.31,143.06,203.31,143.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.84,
    y: 80.37,
    width: 12.74,
    height: 2.43,
    style: {
      fill: "#5E74FF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--construction-crane-2--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.47,463.94h-4.08V283.59h4.08Zm-3.83-.25h3.58V283.84h-3.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 344.76,
    width: 3.83,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 346.43,
    width: 3.83,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 348.48,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 350.15,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 351.82,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 353.49,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 355.17,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 356.47,
    width: 3.83,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 358.51,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 359.81,
    width: 3.83,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 361.86,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 363.53,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 365.2,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 366.88,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 368.55,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 370.22,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 371.52,
    width: 3.83,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 373.57,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 375.24,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 376.54,
    width: 3.83,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 378.59,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 380.26,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 381.93,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 383.61,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 385.28,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 386.58,
    width: 3.83,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 388.25,
    width: 3.83,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 390.3,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 391.97,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 393.64,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 395.32,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 396.99,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 398.66,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 399.96,
    width: 3.83,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 402.01,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 403.31,
    width: 3.83,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 405.35,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 406.65,
    width: 3.83,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 408.7,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 410.37,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 412.05,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 413.72,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 415.39,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 416.69,
    width: 3.83,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 418.74,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 420.03,
    width: 3.83,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 422.08,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 423.76,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 425.43,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 427.1,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 428.77,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 430.45,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 432.12,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 433.79,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 435.09,
    width: 3.83,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 437.14,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 438.81,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 440.48,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 442.16,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 443.83,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 445.5,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 447.18,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 448.85,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 450.15,
    width: 3.83,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 452.19,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 453.87,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 455.54,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 457.21,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 458.89,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 460.56,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 343.2,
    width: 3.83,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 342.01,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 340.45,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 338.89,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 337.33,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 335.77,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 334.22,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 332.66,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 330.72,
    width: 3.83,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 329.54,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 327.6,
    width: 3.83,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 326.42,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 324.86,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 323.3,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 321.74,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 320.18,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 318.62,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 317.06,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 315.5,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 313.94,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 312.01,
    width: 3.83,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 310.82,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 309.26,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 307.71,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 306.15,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 304.59,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 303.03,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 301.47,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 299.91,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 297.97,
    width: 3.83,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 296.79,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 295.23,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 293.67,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 292.11,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 290.55,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 288.99,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 287.43,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.52,
    y: 285.88,
    width: 3.83,
    height: 0.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.1,464.19a.38.38,0,0,1-.37-.38c0-26.66-.06-59.22-.11-90.7s-.11-64.05-.11-90.72a.38.38,0,0,1,.38-.37.37.37,0,0,1,.37.37c0,26.67.06,59.23.11,90.71s.11,64,.11,90.71A.38.38,0,0,1,393.1,464.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.1,326.57a.36.36,0,0,1-.22-.07.38.38,0,0,1-.08-.53l20.05-27.09a.36.36,0,0,1,.52-.08.37.37,0,0,1,.08.52l-20.05,27.1A.36.36,0,0,1,393.1,326.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.1,312.14a.36.36,0,0,1-.22-.07.37.37,0,0,1-.08-.52l20.05-27.1a.37.37,0,0,1,.52-.08.38.38,0,0,1,.08.53L393.4,312A.36.36,0,0,1,393.1,312.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.1,341.86a.36.36,0,0,1-.22-.07.38.38,0,0,1-.08-.53l20.05-27.09a.37.37,0,1,1,.6.44l-20.05,27.1A.36.36,0,0,1,393.1,341.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.1,357.15a.36.36,0,0,1-.22-.07.37.37,0,0,1-.08-.52l20.05-27.1a.37.37,0,1,1,.6.44L393.4,357A.36.36,0,0,1,393.1,357.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.1,372.44a.36.36,0,0,1-.22-.07.37.37,0,0,1-.08-.52l20.05-27.1a.37.37,0,1,1,.6.44l-20.05,27.1A.36.36,0,0,1,393.1,372.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.1,387.73a.36.36,0,0,1-.22-.07.37.37,0,0,1-.08-.52L412.85,360a.37.37,0,0,1,.52-.08.38.38,0,0,1,.08.53L393.4,387.58A.36.36,0,0,1,393.1,387.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.1,403a.38.38,0,0,1-.3-.6l20.05-27.1a.37.37,0,0,1,.52-.08.38.38,0,0,1,.08.53L393.4,402.87A.37.37,0,0,1,393.1,403Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.1,418.32a.38.38,0,0,1-.3-.6l20.05-27.1a.37.37,0,0,1,.52-.08.38.38,0,0,1,.08.53L393.4,418.16A.37.37,0,0,1,393.1,418.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.1,433.61a.38.38,0,0,1-.3-.6l20.05-27.1a.38.38,0,1,1,.6.45l-20.05,27.1A.36.36,0,0,1,393.1,433.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.31,447.94a.35.35,0,0,1-.22-.08.37.37,0,0,1-.08-.52l19.84-26.14a.38.38,0,0,1,.6.45l-19.84,26.14A.36.36,0,0,1,393.31,447.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.33,464.19H393.1a.36.36,0,0,1-.33-.21.37.37,0,0,1,0-.39l20.05-27.09a.38.38,0,0,1,.11-.11V283a.38.38,0,1,1,.75,0V463.81A.38.38,0,0,1,413.33,464.19Zm-19.48-.75H413V437.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.33,324.46a.38.38,0,0,1-.3-.15l-20.34-27.17a.38.38,0,0,1,.6-.45l20.34,27.17a.38.38,0,0,1-.07.53A.39.39,0,0,1,413.33,324.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.33,309.82a.38.38,0,0,1-.3-.16l-20-27.51a.38.38,0,0,1,.61-.44l20.05,27.51a.37.37,0,0,1-.09.52A.35.35,0,0,1,413.33,309.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.33,340a.38.38,0,0,1-.3-.16l-20-27.51a.38.38,0,0,1,.61-.44l20.05,27.51a.38.38,0,0,1-.09.53A.41.41,0,0,1,413.33,340Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.33,355.51a.37.37,0,0,1-.3-.15l-20.34-27.92a.38.38,0,0,1,.08-.52.39.39,0,0,1,.53.08l20.34,27.92a.37.37,0,0,1-.09.52A.34.34,0,0,1,413.33,355.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.33,371a.38.38,0,0,1-.3-.16l-20-27.51a.38.38,0,0,1,.61-.44l20.05,27.51a.38.38,0,0,1-.09.53A.41.41,0,0,1,413.33,371Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.33,386.56a.37.37,0,0,1-.3-.15L393,358.9a.38.38,0,0,1,.09-.53.37.37,0,0,1,.52.09L413.64,386a.37.37,0,0,1-.09.52A.34.34,0,0,1,413.33,386.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.33,402.09a.38.38,0,0,1-.3-.16l-20-27.51a.38.38,0,0,1,.61-.44l20.05,27.51a.38.38,0,0,1-.09.53A.41.41,0,0,1,413.33,402.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.33,417.61a.37.37,0,0,1-.3-.15L393,390a.37.37,0,0,1,.09-.52.36.36,0,0,1,.52.08L413.64,417a.37.37,0,0,1-.09.52A.34.34,0,0,1,413.33,417.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.33,433.14a.35.35,0,0,1-.3-.16l-20-27.51a.38.38,0,0,1,.61-.44l20.05,27.51a.38.38,0,0,1-.09.53A.34.34,0,0,1,413.33,433.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.33,448.66a.37.37,0,0,1-.3-.15L393,421a.37.37,0,0,1,.09-.52.36.36,0,0,1,.52.08l20.05,27.51a.37.37,0,0,1-.09.52A.34.34,0,0,1,413.33,448.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.33,464.19a.37.37,0,0,1-.3-.15l-20-27.52a.38.38,0,0,1,.61-.44l20.05,27.51a.38.38,0,0,1-.09.53A.34.34,0,0,1,413.33,464.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.53,255.33,387.24,247c-20.32,0-41,0-61.73.07s-41.54.06-61.93.06v-1c20.39,0,41.16,0,61.93-.06s41.54-.07,61.92-.07h.19l9.57,8.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.1,258.09a.48.48,0,0,1-.38-.17.49.49,0,0,1,.05-.7l12.48-10.92a.51.51,0,0,1,.68,0l11.26,10.6,11.55-10.61a.51.51,0,0,1,.69,0l10.88,10.6,12.14-10.61a.49.49,0,0,1,.67,0l11.36,10.61,12-10.62a.49.49,0,0,1,.67,0l11.08,10.61,12-10.62a.51.51,0,0,1,.68,0l11,10.59,11.36-10.59a.49.49,0,0,1,.67,0l12.29,10.92a.5.5,0,0,1,0,.71.5.5,0,0,1-.7,0l-11.95-10.62L370.21,258a.5.5,0,0,1-.69,0l-11-10.6L346.5,258a.5.5,0,0,1-.67,0l-11.08-10.61L322.81,258a.49.49,0,0,1-.67,0l-11.37-10.61L298.62,258a.51.51,0,0,1-.68,0l-10.87-10.59L275.52,258a.5.5,0,0,1-.68,0l-11.27-10.61L251.43,258A.54.54,0,0,1,251.1,258.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.53,
    y: 248.31,
    width: 20.93,
    height: 24.64,
    transform: "translate(916 521.27) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.72,273c-.15,0-.26-5.52-.26-12.32s.11-12.33.26-12.33.26,5.52.26,12.33S461.86,273,461.72,273Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.66,273c-.14,0-.26-5.52-.26-12.32s.12-12.33.26-12.33.26,5.52.26,12.33S453.8,273,453.66,273Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.43,258.29H250.85V254.7H470.43Zm-219.08-.5H469.93V255.2H251.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.86,258.29a.26.26,0,0,1-.21-.11.25.25,0,0,1,.07-.35L408.33,250a.25.25,0,0,1,.35.07.24.24,0,0,1-.07.34L397,258.24A.27.27,0,0,1,396.86,258.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.86,258.23h0a.25.25,0,0,1-.22-.28l2.61-20.32a.29.29,0,0,1,0-.13l0-.05,1.64-12.8h0l.54-4.17v0l1.15-8.92a.25.25,0,0,1,.25-.22h1a.25.25,0,0,1,.25.22l.51,4v0l.62,4.86h0l.53,4.17v0L410,258a.26.26,0,0,1-.12.25.26.26,0,0,1-.27,0l-11.47-7.92-1,7.74A.26.26,0,0,1,396.86,258.23Zm2-8,10.52,7.27-1.83-14.38h-8l8.72,6.87a.23.23,0,0,1,.08.28.24.24,0,0,1-.23.16h0Zm-.69-.51,9.24.2L399,243.25Zm.91-7.1h7.81L399.67,238Zm1.23-4.76,7.14,4.52-.58-4.52Zm-.56-.5h6.48l-6-3.9Zm1.15-4.08,5.88,3.84-.49-3.84Zm-.56-.5h5.39l-4.93-3.6Zm1-3.8,4.82,3.52-.45-3.52Zm-.48-.5h4.36l-3.94-3.28Zm.92-3.51,3.82,3.17-.41-3.2Zm0-3.88-.43,3.38,3.47,0Zm.38-.32,2.88,3.16-.41-3.17Zm.22-4.38-.5,3.88h2.56Zm.28-.55,1.77,3.34-.42-3.3Zm-.14-.51,1.42,0-.45-3.53H403Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.65,220.77l-.12,0a.25.25,0,0,1-.1-.34l2.61-4.93a.26.26,0,0,1,.45.24l-2.62,4.92A.25.25,0,0,1,401.65,220.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.11,225a.2.2,0,0,1-.16-.07.24.24,0,0,1,0-.35l3.79-4.16a.25.25,0,0,1,.35,0,.25.25,0,0,1,0,.36l-3.78,4.16A.27.27,0,0,1,401.11,225Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.62,229a.25.25,0,0,1-.16-.44l4.82-4a.24.24,0,0,1,.35,0,.25.25,0,0,1,0,.35l-4.82,4A.27.27,0,0,1,400.62,229Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.07,233.29a.25.25,0,0,1-.21-.1.25.25,0,0,1,.06-.35l5.89-4.3a.25.25,0,0,1,.29.4l-5.89,4.31A.23.23,0,0,1,400.07,233.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.48,237.87a.23.23,0,0,1-.2-.11.25.25,0,0,1,.07-.35l7-4.57a.25.25,0,0,1,.27.41l-7,4.58A.23.23,0,0,1,399.48,237.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.81,243.13a.25.25,0,0,1-.14-.46l8.3-5.26a.26.26,0,0,1,.35.08.24.24,0,0,1-.08.34l-8.3,5.27A.31.31,0,0,1,398.81,243.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,250.18a.26.26,0,0,1-.2-.11.25.25,0,0,1,.06-.35l9.65-7a.25.25,0,0,1,.29.41l-9.65,7A.25.25,0,0,1,398,250.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.28,268.45a.26.26,0,0,1-.25-.25V210.88a.26.26,0,0,1,.25-.25.25.25,0,0,1,.25.25V268.2A.25.25,0,0,1,403.28,268.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.55,
    y: 258.04,
    width: 5.9,
    height: 20.07,
    transform: "translate(817.01 536.14) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.77,
    y: 267.81,
    width: 15.93,
    height: 10.55,
    transform: "translate(799.47 546.17) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.12,
    y: 270.03,
    width: 5,
    height: 8.33,
    transform: "translate(827.24 548.39) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.26,
    y: 281.53,
    width: 25.57,
    height: 3.75,
    transform: "translate(806.1 566.8) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.02,
    y: 277.9,
    width: 20.6,
    height: 2.08,
    transform: "translate(806.64 557.87) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.08,
    y: 279.62,
    width: 18.45,
    height: 1.91,
    transform: "translate(806.6 561.14) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.99,
    y: 333.67,
    width: 20.35,
    height: 2,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.1,
    y: 378.75,
    width: 20.24,
    height: 2,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.1,
    y: 426.23,
    width: 20.24,
    height: 2,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "466.9 250.92 403.18 211.6 299.05 246.87 298.89 246.4 403.24 211.05 403.34 211.11 467.17 250.49 466.9 250.92",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "470.31 254.91 470.06 254.91 470.06 250.83 410.74 250.83 410.74 254.91 410.49 254.91 410.49 250.58 470.31 250.58 470.31 254.91",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.91,
    y: 250.71,
    width: 0.25,
    height: 4.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.22,
    y: 250.71,
    width: 0.25,
    height: 4.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.53,
    y: 250.71,
    width: 0.25,
    height: 4.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.84,
    y: 250.71,
    width: 0.25,
    height: 4.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.15,
    y: 250.71,
    width: 0.25,
    height: 4.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.46,
    y: 250.71,
    width: 0.25,
    height: 4.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.77,
    y: 250.71,
    width: 0.25,
    height: 4.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.08,
    y: 250.71,
    width: 0.25,
    height: 4.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.39,
    y: 250.71,
    width: 0.25,
    height: 4.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.7,
    y: 250.71,
    width: 0.25,
    height: 4.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.02,
    y: 250.71,
    width: 0.25,
    height: 4.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.33,
    y: 250.71,
    width: 0.25,
    height: 4.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.64,
    y: 250.71,
    width: 0.25,
    height: 4.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.95,
    y: 250.71,
    width: 0.25,
    height: 4.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.26,
    y: 250.71,
    width: 0.25,
    height: 4.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.57,
    y: 250.71,
    width: 0.25,
    height: 4.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.88,
    y: 250.71,
    width: 0.25,
    height: 4.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.19,
    y: 250.71,
    width: 0.25,
    height: 4.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.5,
    y: 250.71,
    width: 0.25,
    height: 4.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.81,
    y: 250.71,
    width: 0.25,
    height: 4.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.12,
    y: 250.71,
    width: 0.25,
    height: 4.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425,
    y: 254.95,
    width: 5.44,
    height: 3.08,
    transform: "translate(855.44 512.99) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.39,
    y: 254.95,
    width: 5.44,
    height: 3.08,
    transform: "translate(832.23 512.99) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.73,
    y: 254.95,
    width: 5.44,
    height: 3.08,
    transform: "translate(770.9 512.99) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.1,
    y: 254.95,
    width: 5.44,
    height: 3.08,
    transform: "translate(739.65 512.99) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.48,
    y: 254.95,
    width: 5.44,
    height: 3.08,
    transform: "translate(708.41 512.99) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.86,
    y: 254.95,
    width: 5.44,
    height: 3.08,
    transform: "translate(677.17 512.99) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.24,
    y: 254.95,
    width: 5.44,
    height: 3.08,
    transform: "translate(645.93 512.99) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.62,
    y: 254.95,
    width: 5.44,
    height: 3.08,
    transform: "translate(614.68 512.99) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 254.95,
    width: 5.44,
    height: 3.08,
    transform: "translate(583.44 512.99) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.38,
    y: 254.95,
    width: 5.44,
    height: 3.08,
    transform: "translate(552.2 512.99) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.76,
    y: 254.95,
    width: 5.44,
    height: 3.08,
    transform: "translate(520.96 512.99) rotate(180)",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.92,
    y: 254.95,
    width: 5.44,
    height: 3.08,
    transform: "translate(879.27 512.99) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.83,
    y: 254.95,
    width: 5.44,
    height: 3.08,
    transform: "translate(903.11 512.99) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.75,
    y: 254.95,
    width: 5.44,
    height: 3.08,
    transform: "translate(926.94 512.99) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.64,
    y: 197.66,
    width: 0.5,
    height: 66.9,
    transform: "translate(-8.84 444.92) rotate(-54.14)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250.72,
    cy: 259.11,
    r: 2.27,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.76,259.11a2.27,2.27,0,1,0,2.27-2.28A2.27,2.27,0,0,0,257.76,259.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.72,
    y: 254.34,
    width: 12.86,
    height: 4.11,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.34,
    y: 462.15,
    width: 32.54,
    height: 8.76,
    transform: "translate(807.22 933.06) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.34,
    y: 465.4,
    width: 32.54,
    height: 2.14,
    transform: "translate(807.22 932.95) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.88 465.4 419.01 467.55 417.33 467.55 418.31 465.4 419.88 465.4",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.59 465.4 415.71 467.55 414.04 467.55 415.02 465.4 416.59 465.4",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.3 465.4 412.42 467.55 410.75 467.55 411.73 465.4 413.3 465.4",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410 465.4 409.13 467.55 407.46 467.55 408.43 465.4 410 465.4",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.71 465.4 405.84 467.55 404.17 467.55 405.14 465.4 406.71 465.4",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.42 465.4 402.55 467.55 400.87 467.55 401.85 465.4 403.42 465.4",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.13 465.4 399.25 467.55 397.58 467.55 398.56 465.4 400.13 465.4",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.84 465.4 395.96 467.55 394.29 467.55 395.26 465.4 396.84 465.4",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.54 465.4 392.67 467.55 391 467.55 391.97 465.4 393.54 465.4",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.25 465.4 389.38 467.55 387.7 467.55 388.68 465.4 390.25 465.4",
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.13,465.43c0-.14,7.34-.26,16.4-.26s16.4.12,16.4.26-7.34.26-16.4.26S387.13,465.58,387.13,465.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.13,467.67c0-.15,7.34-.26,16.4-.26s16.4.11,16.4.26-7.34.26-16.4.26S387.13,467.81,387.13,467.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.25,
    y: 210.41,
    width: 1.91,
    height: 1.91,
    transform: "translate(806.42 422.73) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.9,258a3,3,0,0,0-2.44,3.11v6.72h13.26l-.17-9.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.9,258a3.58,3.58,0,0,1,.75-.06l2.16-.05,7.74-.05h.22V258c.07,2.86.13,6.19.21,9.76v.27h-2.21l-11.32,0h-.23v-.22c0-1.65,0-3.16,0-4.52q0-1,0-1.89a4.24,4.24,0,0,1,.24-1.62,2.87,2.87,0,0,1,1.57-1.62,1.61,1.61,0,0,1,.79-.18s-.27.08-.73.31a2.84,2.84,0,0,0-1.38,1.58,4.08,4.08,0,0,0-.18,1.53q0,.89,0,1.89c0,1.36,0,2.87,0,4.52l-.22-.23,11.32,0h1.94l-.26.26c0-3.57-.09-6.9-.13-9.76l.22.21-7.73-.13-2.16-.08A2.67,2.67,0,0,1,394.9,258Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.78,260.62a22.1,22.1,0,0,1,5.24,4.32,11.18,11.18,0,0,1-2.79-2A11.41,11.41,0,0,1,396.78,260.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.4,262.59c.09-.11,1,.52,2.05,1.4s1.81,1.69,1.71,1.8-1-.51-2.05-1.4S396.3,262.7,396.4,262.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.29,278.36a94.84,94.84,0,0,1-.26-10,94.84,94.84,0,0,1,.26-10,98.18,98.18,0,0,1,.26,10A98.18,98.18,0,0,1,411.29,278.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.88,278.36c0-.14,4.73-.26,10.55-.26s10.55.12,10.55.26-4.72.26-10.55.26S392.88,278.5,392.88,278.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.88,280c0-.14,4.65-.26,10.37-.26s10.37.12,10.37.26a101.33,101.33,0,0,1-10.37.26A101.49,101.49,0,0,1,392.88,280Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.88,281.53a101.49,101.49,0,0,1,10.37-.26,101.33,101.33,0,0,1,10.37.26c0,.14-4.64.26-10.37.26S392.88,281.67,392.88,281.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.94,
    y: 245.27,
    width: 7.35,
    height: 1.4,
    transform: "translate(601.23 491.94) rotate(180)",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boxes--inject-19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.66,
    y: 447.23,
    width: 38.6,
    height: 23.96,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.27,
    y: 458.45,
    width: 38.6,
    height: 12.74,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.06,
    y: 445.56,
    width: 38.6,
    height: 25.44,
    style: {
      fill: "#5E74FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.67,
    y: 458.25,
    width: 38.6,
    height: 12.74,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.28,
    y: 432.81,
    width: 38.6,
    height: 12.74,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.67,
    y: 445.56,
    width: 38.6,
    height: 12.74,
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/construction.630c9fa1559355e01c222f0361675168.svg";
export { ForwardRef as ReactComponent };